import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const dropdownService = {

    userListDropdown: async () => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/dropdown/userlist`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    }

};

export default dropdownService;